export var accountReducer = function (state, action) {
    return state;
};
